import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import api from '../services/api'

interface ProjectDetail {
  id: string
  project_code: string
  name: string
  description?: string
  status: string
  start_date: string
  end_date?: string
  budget_ht: number
  paid_ht: number
  remaining_ht: number
  client: {
    name: string
    industry?: string
  }
  solution?: {
    name: string
  }
  responsible_user?: {
    first_name: string
    last_name: string
  }
  device_count: number
  event_count: number
  invoice_count: number
}

export default function ProjectDetail() {
  const { id } = useParams<{ id: string }>()

  const { data: project, isLoading } = useQuery<ProjectDetail>({
    queryKey: ['project', id],
    queryFn: async () => {
      const response = await api.get(`/projects/${id}`)
      return response.data
    },
    enabled: !!id
  })

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  if (!project) {
    return (
      <div className="text-center py-12">
        <h3 className="text-lg font-medium text-gray-900">Project not found</h3>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="border-b border-gray-200 pb-5">
        <h1 className="text-2xl font-bold text-gray-900">{project.name}</h1>
        <p className="mt-1 text-sm text-gray-500">{project.project_code}</p>
      </div>
      
      <div className="card p-6">
        <p className="text-gray-600">Project details will be implemented here.</p>
      </div>
    </div>
  )
}